module.exports = __webpack_public_path__ + "img/makePublic.970929ea.svg";